import { gql } from "@apollo/client";

export const GET_FORM_QUERY = gql`
fragment donationBlockFields on ComponentBlocksDonationBlock {
  donation_block {
            id
            name
            label
            sort
            allows_any_donation_amount
            donation_style
            donation_description
            image {
              url
            }
            donation_amounts {
              description
              amount
            }
            checkoutLabel
\t}
}

fragment twoColumnFields on ComponentBlocksTwoColumnBlock {
    id
    two_column_block {
        id
        leftColumn {
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {\t
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
         ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
          }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        }
        rightColumn {
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {\t
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
        ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
            }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        }
    }
}

fragment threeColumnFields on ComponentBlocksThreeColumnBlock {
    id
    three_column_block {
        id
        leftColumn {
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {	
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
         ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
          }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        }
        middleColumn {
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {	
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
        ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
            }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        }
        rightColumn {
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {	
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
        ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
            }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        }
    }
}

fragment fourColumnFields on ComponentBlocksFourColumnBlock {
    id
    four_column_block {
        id
        leftColumn {
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {	
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
         ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
          }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        }
        middleLeftColumn {
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {	
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
        ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
            }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        }
        middleRightColumn {
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {	
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
        ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
            }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        }
        rightColumn {
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {	
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
        ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
            }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        }
    }
}

fragment questionBlockFields on ComponentBlocksQuestionBlock {
    question_block {
        id
        label
        type
        rows
        columns
        required
        singleLine
        question_block_answers(sort: "priority:desc") {
            id
            text
        }
    }
}

fragment checkoutBlockFields on ComponentBlocksCheckoutBlock {
    id
    label
}

fragment productFields on ComponentBlocksProductBlock {
    products_block {
            id
            header
            footer
            checkboxDisplay
            radioDisplay
            image {
                url
              }
            products(sort: "priority:desc") {
              id
              fee
              image {
                url
              }
              description
              minQuantity
              maxQuantity
              quantityAvailable
              amountSold
              product_activity_in_processes {
                quantity
              }
              productActivityInProgressText
              confirmationHTML
              displayName
              price
              name
              isPhysical
              shippingSize
            }
    }
}

fragment merchandiseFields on ComponentBlocksMerchandiseBlock {
    id
    header
    footer
    columns
    products_block {
        id
        checkboxDisplay
        radioDisplay
        products(sort: "priority:desc") {
            id
            fee
            image { url }
            description
            minQuantity
            maxQuantity
            quantityAvailable
            amountSold
            product_activity_in_processes { quantity }
            productActivityInProgressText
            confirmationHTML
            displayName
            price
            name
            isPhysical
            shippingSize
        }
    }
}

fragment buyersBlockFields on ComponentBlocksBuyersBlock {
    id
    label
    BuyersBlockFields {
        address {
            required
        }
        phone {
            required
            type
        }
    }
}


fragment patronFields on ComponentBlocksPatronInformationBlock {
    id
    label
    PatronFields {
        address {
            required
        }
        phone {
            required
            type
        }
        dob {
            required
        }
        birthday {
            required
        }
    }
}

fragment htmlFields on ComponentBlocksHtmlBlock {
    id
    html_block {
        id
        html
    }
}

fragment membershipComparisonFields on ComponentBlocksMembershipComparisonBlock {
    id
    title
    subtitle
    memberships {
        name
        price
        priceDescription
        subtitle
        isBestValue
        buttonText
        product {
            id
            displayName
            price
            quantityAvailable
            amountSold
            productActivityInProgressText
            confirmationHTML
        }
        featureValues
    }
    features {
        featureName
        featureDescription
        isHighlight
    }
}

fragment personFields on ComponentBlocksP2Block {
    person_block {
        id
        label
        fields {
            ... on ComponentPerson2ComponentsNameFields {
            required
            }
            ... on ComponentPerson2ComponentsAddressFields {
            required
            }
            ... on ComponentPerson2ComponentsPhoneFields {
            type
            required
            }
            ... on ComponentPerson2ComponentsRelationshipFields {
            label
            required
            }
            ... on ComponentPerson2ComponentsEmailAddressField {
            required
            }
            ... on ComponentPerson2ComponentsDateOfBirthFields {
            required
            }
            ... on ComponentPerson2ComponentsBirthdayField {
            required
            }
        }
    }
}

query page($venue: String!, $path: String!) {
  forms(where:{ venue: {path: $venue}, path: $path}) {
    id
    name
    googleAnaltyicsId
    successHTML
    redirectToURL
    failureHTML
    checkoutHTML
    formType
    label
    css
    showCartTotal
    skipShoppingCart
    enableRecaptcha
    testMode
    applePayEnabled
    showSocialMediaShareButtonsOnCheckout
    nonRecurringTerminalId {
      id
      terminal_id
      terminal_secret
      merchant_id
      active
    }
    recurringTerminalId {
      id
      terminal_id
      terminal_secret
      merchant_id
      active
    }
    donationSettings {
      rate
      beforeText
      afterText
      placement
      selectedByDefault
    }
    form_fees {
      label
      name
      amount
      type
      applied_per
      item_id
    }
    venue {
      id
      css
      primaryColor
      secondaryColor
      address
      City
      State
      Zip
      phone
      email
      website
      webhookErrorEmail
      hideComments
      hideCustRef
      googleTagManager
      remote_stylesheets {
        url
      }
      logo {
        url
      }
      creditCardBrandsImage {
        url
      }
      tag
      tunl_username
      paymentProcessor
      worldnet_terminal_id
      worldnet_terminal_secret
      worldnet_currency
      bridgepay_hpp_id
      bridgepay_public_key
      bridgepay_organization_id
      hostedFieldsLogoAlignment
      hostedFieldsLogoLayout
      applePayEnabled
      shippingConfig {
        enabled
        shippingItemID
        mediumUnits
        largeUnits
        boxes {
          size
          price
          unitCapacity
        }
      }
    }
    pages(sort: "order:asc,id:asc") {
      id
      productsRequired
      css
      label
      order
      blocks {
       ... on ComponentBlocksComponentUploadBlock {
          id
          url
        }
        ... on ComponentBlocksDonationGoalBlock {
           goal
           toDateText
           giftsText
           goalText
           giftsSingleItemText
           biasDollars
           biasNumGifts
        }
        ... on ComponentBlocksDonationGoalNameEntryBlock {
           optInText
        }
        ... on ComponentBlocksDonationSocialMediaShareBlock {
           headerText
           sharedQuote
           sharedImage {
                url
           }
        }
        ... on ComponentBlocksDonationGoalRecentDonorsList {
           sortOrder
           listType
           headerText
        }
        ... on ComponentBlocksTwoColumnBlock {
            ...twoColumnFields
        }
        ... on ComponentBlocksThreeColumnBlock {
            ...threeColumnFields
        }
        ... on ComponentBlocksFourColumnBlock {
            ...fourColumnFields
        }
        ... on ComponentBlocksAccordionBlock {
            id
            accordion_block {
                defaultExpanded
                id
            }
        }
        ... on ComponentBlocksDonationBlock {
            ...donationBlockFields
        }
        ... on ComponentBlocksQuestionBlock {\t
            ...questionBlockFields
        }
        ... on ComponentBlocksCheckoutBlock {
            ...checkoutBlockFields
        }
        ... on ComponentBlocksProductBlock {
            ...productFields
        }
        ... on ComponentBlocksMerchandiseBlock {
            ...merchandiseFields
        }
        ... on ComponentBlocksP2Block {
            ...personFields
        }
        ... on ComponentBlocksPatronInformationBlock {
            ...patronFields
        }
        ... on ComponentBlocksBuyersBlock {
            ...buyersBlockFields
        }
        ... on ComponentBlocksHtmlBlock {
            ...htmlFields
        }
        ... on ComponentBlocksMembershipComparisonBlock {
            ...membershipComparisonFields
        }
      }
    }
  }
 }`;
